import { render } from "./PrivacyConsentCheckbox.vue?vue&type=template&id=0d0e8a1c"
import script from "./PrivacyConsentCheckbox.vue?vue&type=script&lang=js"
export * from "./PrivacyConsentCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__